// Professional logo-style plate for the client wall.
// NOTE: These are styled brand lockups (monogram + wordmark), not official
// trademarked logos. Replace with official logo image files when available.
export default function ClientLogo({ name, short }) {
  return (
    <div
      data-testid={`client-logo-${name.toLowerCase().replace(/\s+/g, "-")}`}
      className="group mx-3 flex h-16 w-52 items-center gap-3 rounded-xl border border-slate-800 bg-[#111c33]/50 px-4 transition-colors duration-300 hover:border-[#2563EB]/60 hover:bg-[#111c33]"
    >
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-slate-800 font-display text-sm font-extrabold text-slate-400 transition-colors duration-300 group-hover:bg-[#2563EB] group-hover:text-white">
        {short}
      </span>
      <span className="flex flex-col leading-tight">
        <span className="font-display text-sm font-bold tracking-tight text-slate-400 transition-colors duration-300 group-hover:text-white">
          {name}
        </span>
        <span className="text-[10px] font-medium uppercase tracking-widest text-slate-600 transition-colors group-hover:text-[#60A5FA]">
          Client
        </span>
      </span>
    </div>
  );
}
